import React, { useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";

const Facility = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Header toggleSidebar={() => setOpen(true)} />
            <Sidebar isOpen={open} close={() => setOpen(false)} />
            {/* HERO */}
            <div className="about-hero">
                <div className="about-overlay">
                    <h1>FACILITY</h1>
                    <Breadcrumb />
                </div>
            </div>
            <div className="container contact-page">

                <div className="vision-card admission-card">

                    <h2 className="admission-title">
                        School Facility
                    </h2>

                    <p className="facility-intro">
                        Nav Jeevan Mission School imparts education as a process by which 
                        a child is molded into an emotionally balanced. Physically healthy, 
                        intellectually objective and spiritually conscious individual who 
                        can fruitfully and happily live in society and spiritually conscious 
                        individual who can fruitfully and happily live in society with others. 
                        The school seeks to make its student aware of these concerns and 
                        responsibilities through a well designed programmed of formal and 
                        informal education. The school holds the belief that academic 
                        qualifications alone do not make an individual truly educated: 
                        the school therefore, encourages its students to avail themselves 
                        of many opportunities for total growth. Besides Nav Jeevan Mission School 
                        has integrity to service and respect for mankind. The school motto "arise" and "shine" 
                        is a constant reminder of our responsibility towards spreading the light of learning 
                        and of the gospel truth to the world at large.
                    </p>

                </div>

            </div>

            <Footer />
        </>
    );
};

export default Facility;